import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Notifications from './Notifications';
import OperationService from '../../../../services/OperationService/OperationService';
import QueueService from '../../../../services/QueueService/QueueService';
/**
 * @Description This function lets you return Dashboard component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function QuickView () {

    const { t } = useTranslation();
    const label = 'CONTENT.DASHBOARD.';
    // Initial states
    const [state, setState] = useState({ completed: 0, total: 0, inprogress: 0, pending: 0 });
    
    // Fetch data on start
    useEffect(() => { fetchData(); }, []);
    // Fetch Quick View data
    const fetchData = async () => {
        let completed = 0, total = 0, inprogress = 0, pending = 0;
        let today = new Date();
        let yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        // Fetch Operation Count data
        let res = await OperationService.getOperationCount(yesterday.toISOString(), today.toISOString(), 'automation');
        if (res?.status && res.data) {
            let { completedCount, totalCount } = res.data[0];
            completed = completedCount ? completedCount : 0;
            total = totalCount ? totalCount : 0;
        }
        res = await QueueService.getQueueStatus(['IN-PROGRESS']);
        if (res?.status && res.data) { inprogress = res.data.count; }
        res = await QueueService.getQueueStatus(['PENDING']);
        if (res?.status && res.data) { pending = res.data.count; }
        // Update state value
        setState({ completed, total, inprogress, pending });
    };
    return (
        <div style={{ marginBottom: '3%' }}>
            <div className="db-row">
                <div className="db-hlabel" style={{ fontSize: '2em' }}>{t(label+'HELLO')} &#128075;</div>
                <div className="db-label" style={{ color: '#B0B0B0' }}>{t(label+'LAST-LOGIN')}: 10 Jul, 2021; 8:20:33 PM</div>
            </div>
            <Notifications/>
            <div className="db-page" style={{ padding: 0 }}>
                <div className="daily-completed">
                    {t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                        <span><span>{state.total}</span> <span style={{ color: '#b6b6b6' }}>günlük tasktan</span> <span>{state.completed}</span> tamamlandı</span>:
                        <span><span>{state.completed}</span> <span style={{ color: '#b6b6b6' }}>daily tasks completed</span> <span>out of {state.total}</span></span>
                    }
                    <div style={{ display: 'flex', marginTop: '2%' }}>
                        <div style={{
                            width: (state.completed / state.total * 100) + '%',
                            border: '3px solid #002742', borderRadius: '3px 0 0 3px'
                        }}></div>
                        <div style={{
                            width: ((state.completed - state.total) / state.total * 100) + '%',
                            border: '3px solid #ebeff2', borderRadius: '0 3px 3px 0'
                        }}></div>
                    </div>
                </div>
                <div style={{ padding: '3%' }}>
                    <div className="db-hlabel">{t(label+'QUICK')}</div>
                    <div className="db-row quick-cards">
                        <div className="db-column db-qw green">
                            <div className="db-mincard">
                                <div>{t(label+'AVAILABLE')}</div>
                                <div>{0}</div>
                            </div>
                        </div>
                        <div className="db-column db-qw blue">
                            <div className="db-mincard">
                                <div>{t(label+'PROGRESS')}</div>
                                <div>{state.inprogress}</div>
                            </div>
                        </div>
                        <div className="db-column db-qw orange">
                            <div className="db-mincard">
                                <div>{t(label+'QUEUE')}</div>
                                <div>{state.pending}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default QuickView;